import { create } from "zustand"

export const useAddsalesStore = create((set) => ({
    // addsales: [
    //     {
    //         id: 1,
    //         first_name: "Иван",
    //         last_name: "Иванов",
    //         dialog: 'https://vk.com/im?sel=1',
    //         product: 'product1',
    //         class: 'class1',
    //         subject: 'subject1',
    //         tags: 'Tag3',
    //         purchasedProducts: ['Product1', 'Product2']
    //     },
    //     {
    //         id: 2,
    //         first_name: "Никита",
    //         last_name: "Овчинников",
    //         dialog: 'https://vk.com/im?sel=1',
    //         product: 'product2',
    //         class: 'class2',
    //         subject: 'subject2',
    //         tags: '',
    //         purchasedProducts: []
    //     },
    //     {
    //         id: 3,
    //         first_name: "Иван",
    //         last_name: "Овчинников",
    //         dialog: 'https://vk.com/im?sel=1',
    //         product: 'product3',
    //         class: 'class3',
    //         subject: 'subject3',
    //         tags: 'Tag1',
    //         purchasedProducts: ['Product1', 'Product2', 'Product3']
    //     },
    // ],
    addsales: [],
    setAddsales: (newAddsales) => set({ addsales: newAddsales }),
    updateAddsale: (addsale) => set(state => ({
        addsales: state.addsales.map(as => as.id === addsale.id ? addsale : as)
    })),
}))
